import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import "../Analytics.scss";
import testIds from "constants/testIds";
import { getLabelWithTranslationFallback } from "helpers/getLabel";
import PillTabs from "components/atoms/PillTabs/PillTabs";

function AnalyticTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  const requestStatus = [
    {
      eventKey: "reports",
      title: intl.formatMessage({
        id: "analytics.reports",
        defaultMessage: "Reports",
      }),
      testId: testIds.ANALYTICS_REPORT_TAB,
    },
    {
      eventKey: "location",
      title: getLabelWithTranslationFallback("Payment location", {
        style: "capitalize",
        translation: <FormattedMessage id="general.paymentLocation" defaultMessage="Payment location" />,
      }),
      testId: testIds.ANALYTICS_LOCATION_TAB,
    },
    {
      eventKey: "providers",
      title: intl.formatMessage({
        id: "general.providers",
        defaultMessage: "Providers",
      }),
      testId: testIds.ANALYTICS_PROVIDER_TAB,
    },
    {
      eventKey: "freight modes",
      title: intl.formatMessage({
        id: "general.freightModes",
        defaultMessage: "Freight Modes",
      }),
      testId: testIds.ANALYTICS_FREIGHT_MODE_TAB,
    },
    {
      eventKey: "billing",
      title: intl.formatMessage({
        id: "components.molecules.navigation.billing",
        defaultMessage: "Billing",
      }),
      testId: testIds.ANALYTICS_BILLING_TAB,
    },
  ];

  const searchParams = new URLSearchParams(location.search);
  const filter = searchParams.get("filter");

  const [status, setStatus] = useState(filter);

  useEffect(() => {
    if (filter) {
      setStatus(filter);
    }
  }, [filter]);

  return (
    <>
      {/* Regular view */}
      <div className={`${filter !== "new report" && "analytics-regular-nav mb-xs-2"}`}>
        <PillTabs
          defaultActiveKey={filter}
          activeKey={status}
          id="quote-statuses"
          onSelect={(eventKey) => {
            setStatus(eventKey);
            navigate({
              pathname: location.pathname,
              search: `?filter=${eventKey}`,
            });
          }}
          tabItems={requestStatus}
        />
      </div>
    </>
  );
}

export default AnalyticTabs;
